// extracted by mini-css-extract-plugin
export default {"card":"q0-z","carouselContainer":"r0-z","carouselContent":"s0-z"};